import React, { useState } from 'react'

const ConversationPDF = props => {
  return (
    <iframe
      className="conversation-pdf-frame"
      src={props.pdf.url}
      style={{ width: '100%', height: '100%' }}
    />
  )
}

export default ConversationPDF
